var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('AppHeader',{attrs:{"navArr":_vm.navArr,"index":_vm.currentIndex}}),_c('div',{staticClass:"main-content"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }